import { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageHero from '@/components/PageHero';
import FaqItem from './components/FaqItem';
import { HERO, PC, FAQ_TITLE, FAQS } from './config';
import PcDownloadButton from './components/PcDownloadButton';
import styles from './index.module.scss';

export default function Download() {
  const [openSet, setOpenSet] = useState<Set<number>>(new Set());

  const toggle = (i: number) =>
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(i)) {
        next.delete(i);
      } else {
        next.add(i);
      }
      return next;
    });

  return (
    <div className={styles.page}>
      <Header />
      <main>
        <PageHero image={HERO.image} centered={false} innerClassName={styles.mobileInner}>
          <div className={styles.mobileLeft}>
            <div className={styles.textGroup}>
              <span className={styles.tag}>{HERO.tag}</span>
              <h2 className={`${styles.sectionTitle} ${styles.mobileTitle}`}>{HERO.title}</h2>
            </div>
            <div className={styles.qrGroup}>
              <div className={styles.qrBody}>
                <img className={styles.qrImage} src={HERO.qr.image} alt="扫码下载" />
              </div>
              <p className={styles.qrVersions}>{HERO.qr.versions}</p>
            </div>
          </div>
        </PageHero>

        {/* PC 客户端 */}
        <section className={styles.pc}>
          <div className={styles.pcMedia}>
            <img src={PC.background} alt="" loading="lazy" />
          </div>
          <div className={styles.pcContent}>
            <div className={styles.pcInner}>
              <div className={styles.textGroup}>
                <span className={styles.tag}>{PC.tag}</span>
                <h2 className={styles.sectionTitle}>{PC.title}</h2>
              </div>
              <div className={styles.actionGroup}>
                <PcDownloadButton />
                <p className={styles.note}>{PC.note}</p>
              </div>
            </div>
          </div>
        </section>

        {/* 常见问题 */}
        <section className={styles.faq}>
          <div className={styles.faqInner}>
            <h2 className={styles.faqTitle}>{FAQ_TITLE}</h2>
            <div className={styles.faqList}>
              {FAQS.map((item, i) => (
                <FaqItem
                  key={i}
                  question={item.question}
                  open={openSet.has(i)}
                  onToggle={() => toggle(i)}
                  last={i === FAQS.length - 1}
                >
                  {item.answer}
                </FaqItem>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
